import { Box, Typography, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import Icon from '@mui/material/Icon';

interface PageHeaderProps {
  title: string;
  icon: FC;
  children?: ReactNode;
  colour?: string;
  titleAction?: ReactNode;
}

const PageHeader = (props: PageHeaderProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Box display="flex" gap={1} alignItems="center">
        <Icon component={props.icon} sx={{ fontSize: '32px', color: theme.palette.primary.main }} />
        <Typography variant="h5" fontWeight={700} textTransform="uppercase">
          {props.title}
        </Typography>
        {props.titleAction}
      </Box>
      {props.children}
    </Box>
  );
};

export default PageHeader;
